/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChildMemoDto } from '../../models/child-memo-dto';

export interface ParentChildMemoControllerFindOneMemoByParent$Params {
  id: string;
}

export function parentChildMemoControllerFindOneMemoByParent(http: HttpClient, rootUrl: string, params: ParentChildMemoControllerFindOneMemoByParent$Params, context?: HttpContext): Observable<StrictHttpResponse<ChildMemoDto>> {
  const rb = new RequestBuilder(rootUrl, parentChildMemoControllerFindOneMemoByParent.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChildMemoDto>;
    })
  );
}

parentChildMemoControllerFindOneMemoByParent.PATH = '/api/child-memo/parent/{id}';
